import initAssessmentFrom from './assessment';
import initResourceForm from './resource';

const initForm = ({ isAssessmentForm, isResourceForm, data }, callback) => {
  if (isAssessmentForm) {
    initAssessmentFrom(data);
  } else if (isResourceForm) {
    initResourceForm(data);
  }

  callback && callback();
};

export default initForm;
